<template>
    <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    max-width="700px"
    scrollable
    z-index="210"
  >
        <v-card >
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">Deal Info</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row v-if="!loading">
                    <v-col cols="12" sm="12">
                        <h5 class="text-h7 mb-1 pa-0">Address</h5>
                        <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                            <template v-slot:default>
                                <tbody class="rpd-d-tbody">
                                    <!-- <tr>
                                        <td>
                                            <h2 class="text-h6 text-primary-600 mt-2">Address</h2>
                                        </td>
                                        <td></td>
                                    </tr> -->
                                    <tr v-if="(info.property && !Array.isArray(info.property)) && (info.property.scheme && !Array.isArray(info.property.scheme))">
                                        <td >Scheme:</td>
                                        <td>
                                            <a @click="viewScheme(info.property.scheme.id)">{{ info.property.scheme.name }}</a>
                                        </td>
                                    </tr>
                                    <tr v-else-if="info.scheme && !Array.isArray(info.scheme)">
                                        <td >Scheme:</td>
                                        <td>
                                            <a @click="viewScheme(info.scheme.id)">{{ info.scheme.name }}</a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.property && !Array.isArray(info.property)">
                                        <td >Property:</td>
                                        <td>
                                            <a @click="viewProperty(info.property.id)">{{ info.property.address.full_address }}</a>
                                        </td>
                                    </tr>
                                    

                                </tbody>
                            </template>
                        </v-simple-table>


                        <h5 class="text-h7 mb-1 mt-6 pa-0">Deal</h5>
                        <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                            <template v-slot:default>
                                <tbody class="rpd-d-tbody">
                                    <!-- <tr>
                                        <td>
                                            <h2 class="text-h6 text-primary-600 mt-2">Deal</h2>
                                        </td>
                                        <td></td>
                                    </tr> -->
                                    <tr>
                                        <td class="deal-td">Deal Type:</td>
                                        <td style="text-transform: capitalize;">{{ formatData(info.deal_type) }}</td>
                                    </tr>
                                    <tr v-if="info.effective_date || info.lease_start_date">
                                        <td>Effective Date</td>
                                        <td>
                                            <span v-if="info.effective_date && (info.deal_type == 'rent_review' || info.deal_type == 'subletting' || info.deal_type == 'tenant_change' || info.deal_type == 'sale')">{{ formatDate(info.effective_date) }}</span>
                                            <span v-else-if="info.lease_start_date && (info.deal_type == 'lease_renewal' || info.deal_type == 'new_letting')">{{ formatDate(info.lease_start_date) }}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="info.created_at">
                                        <td >Created At:</td>
                                        <td>{{ info.created_at }}</td>
                                    </tr>
                                    <tr v-if="info.creator && !Array.isArray(info.creator)">
                                        <td >Creator:</td>
                                        <td>
                                            <a @click="viewUser(info.creator.id)">{{ info.creator.name }}</a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.client && !Array.isArray(info.client)">
                                        <td >Client:</td>
                                        <td v-if="info.client">
                                            <a @click="viewCompany(info.client.id)">{{ info.client.name }}</a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Client</td>
                                    </tr>
                                    
                                    <tr v-if="info.prev_tenant && !Array.isArray(info.prev_tenant)">
                                        <td >Previous Tenant:</td>
                                        <td>
                                            <a @click="viewCompany(info.prev_tenant.id)">{{ info.prev_tenant.name }}</a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_tenant_legal && !Array.isArray(info.prev_tenant_legal)">
                                        <td >Previous Tenant Legal:</td>
                                        <td>
                                            <a @click="viewCompany(info.prev_tenant_legal.id)">{{ info.prev_tenant_legal.name }}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <h5 class="text-h7 mb-1 mt-6 pa-0">Lease Info</h5>
                        <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                            <template v-slot:default>
                                <tbody class="rpd-d-tbody">

                                    <template>
                                    <!-- <tr>
                                        <td>
                                            <h2 class="text-h6 text-primary-600 mt-2">Lease Info</h2>
                                        </td>
                                        <td></td>
                                    </tr> -->
                                    <tr>
                                        <td >Tenant:</td>
                                        <td v-if="info.tenant && !Array.isArray(info.tenant)">
                                            <a @click="viewCompany(info.tenant.id)">{{ info.tenant.name }}</a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">Vacant</td>
                                    </tr>
                                    <tr>
                                        <td >Tenant Legal:</td>
                                        <td v-if="info.tenant_legal && !Array.isArray(info.tenant_legal)">
                                            <a @click="viewCompany(info.tenant_legal.id)">{{ info.tenant_legal.name }}</a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">Vacant</td>
                                    </tr>
                                    
                                    <tr v-if="info.reason">
                                        <td >Reason:</td>
                                        <td style="text-transform: capitalize;">{{ formatData(info.reason) }}</td>
                                    </tr>
                                    <tr v-if="info.planning">
                                        <td >Planning:</td>
                                        <td>{{ info.planning }}</td>
                                    </tr>
                                    <tr v-if="info.sale_type">
                                        <td >Sale Type:</td>
                                        <td style="text-transform: capitalize;">{{ formatData(info.sale_type) }}</td>
                                    </tr>

                                    <!-- TODO NOTE TODO NOTE TODO NOTE TODO NOTE NOTE -->
                                    <!-- Sort out currency stuff, you wanna make it so that it displays the pound symbol for example, before all the currency related fields. -->

                                    <tr v-if="info.rent_pa || info.rent_sqft || info.rateable_value || info.service_charge || info.sale_price">
                                        <td >Currency:</td>
                                        <td>{{ info.currency }}</td>
                                    </tr>
                                    <tr v-if="info.sale_price">
                                        <td >Sale Price:</td>
                                        <td>{{ currencyFormat(info.sale_price) }}</td>
                                    </tr>
                                    <tr v-if="info.rent_pa">
                                        <td >Rent PA:</td>
                                        <td>{{ currencyFormat(info.rent_pa) }}</td>
                                    </tr>
                                    <tr v-if="info.rent_sqft">
                                        <td >Rent SQFT:</td>
                                        <td>{{ currencyFormat(info.rent_sqft) }}</td>
                                    </tr>
                                    <tr v-if="info.prev_rent_pa">
                                        <td >Previous Rent PA:</td>
                                        <td>{{ currencyFormat(info.prev_rent_pa) }}</td>
                                    </tr>
                                    <tr v-if="info.prev_rent_sqft">
                                        <td >Previous Rent SQFT:</td>
                                        <td>{{ currencyFormat(info.prev_rent_sqft) }}</td>
                                    </tr>
                                    <tr v-if="info.rateable_value">
                                        <td >Rateable Value:</td>
                                        <td>{{ currencyFormat(info.rateable_value) }}</td>
                                    </tr>
                                    <tr v-if="info.service_charge">
                                        <td >Service Charge:</td>
                                        <td>{{ currencyFormat(info.service_charge) }}</td>
                                    </tr>
                                    <tr v-if="info.incentive">
                                        <td >Incentive:</td>
                                        <td>{{ info.incentive }}</td>
                                    </tr>
                                    <tr v-if="info.rent_review_clause">
                                        <td >Rent Review Clause:</td>
                                        <td>{{ info.rent_review_clause }}</td>
                                    </tr>
                                    <tr v-if="info.break_clause">
                                        <td >Break Clause:</td>
                                        <td>{{ info.break_clause }}</td>
                                    </tr>
                                    <tr v-if="info.lease_start_date">
                                        <td >Lease Start Date:</td>
                                        <td>{{ formatDate(info.lease_start_date) }}</td>
                                    </tr>
                                    <tr v-if="info.lease_end_date">
                                        <td >Lease End Date:</td>
                                        <td>{{ formatDate(info.lease_end_date) }}</td>
                                    </tr>
                                    <tr v-if="info.next_review_date">
                                        <td >Next Review Date:</td>
                                        <td>{{ formatDate(info.next_review_date) }}</td>
                                    </tr>
                                    <tr v-if="info.break_date">
                                        <td >Break Date:</td>
                                        <td>{{ formatDate(info.break_date) }}</td>
                                    </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <h5 class="text-h7 mb-1 mt-6 pa-0">Contacts</h5>
                        <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                            <template v-slot:default>
                                <tbody class="rpd-d-tbody">
                                    <!-- <tr>
                                        <td>
                                            <h2 class="text-h6 text-primary-600 mt-2">Contacts</h2>
                                        </td>
                                        <td></td>
                                    </tr> -->
                                    <tr>
                                        <td >Landlords:</td>
                                        <td v-if="info.landlords.data.length > 0">
                                            <a class="mr-1" v-for="(company, index) in info.landlords.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.landlords.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Landlords</td>
                                    </tr>
                                    <tr>
                                        <td >Landlord Contacts:</td>
                                        <td v-if="info.landlord_contacts.data.length > 0">
                                            <a class="mr-1" v-for="(contact, index) in info.landlord_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.landlord_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Landlord Contacts</td>
                                    </tr>
                                    <tr>
                                        <td >Landlord Agents:</td>
                                        <td v-if="info.landlord_agents.data.length > 0">
                                            <a class="mr-1" v-for="(company, index) in info.landlord_agents.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.landlord_agents.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Landlord Agents</td>
                                    </tr>
                                    <tr>
                                        <td >Landlord Agent Contacts:</td>
                                        <td v-if="info.landlord_agent_contacts.data.length > 0">
                                            <a class="mr-1" v-for="(contact, index) in info.landlord_agent_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.landlord_agent_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Landlord Agent Contacts</td>
                                    </tr>
                                    <tr v-if="info.prev_landlords && info.prev_landlords.data.length > 0">
                                        <td >Previous Landlords:</td>
                                        <td>
                                            <a class="mr-1" v-for="(company, index) in info.prev_landlords.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.prev_landlords.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_landlord_contacts && info.prev_landlord_contacts.data.length > 0">
                                        <td >Previous Landlord Contacts:</td>
                                        <td>
                                            <a class="mr-1" v-for="(contact, index) in info.prev_landlord_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.prev_landlord_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_landlord_agents && info.prev_landlord_agents.data.length > 0">
                                        <td >Previous Landlord Agents:</td>
                                        <td>
                                            <a class="mr-1" v-for="(company, index) in info.prev_landlord_agents.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.prev_landlord_agents.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_landlord_agent_contacts && info.prev_landlord_agent_contacts.data.length > 0">
                                        <td >Previous Landlord Agent Contacts:</td>
                                        <td>
                                            <a class="mr-1" v-for="(contact, index) in info.prev_landlord_agent_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.prev_landlord_agent_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td>
                                            <h2 class="text-h6 text-primary-600 mt-2">Tenancy</h2>
                                        </td>
                                        <td></td>
                                    </tr> -->
                                    <tr>
                                        <td >Tenant Contacts:</td>
                                        <td v-if="info.tenant_contacts.data.length > 0">
                                            <a class="mr-1" v-for="(contact, index) in info.tenant_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.tenant_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Tenant Contacts</td>
                                    </tr>
                                    <tr>
                                        <td >Tenant Agents:</td>
                                        <td v-if="info.tenant_agents.data.length > 0">
                                            <a class="mr-1" v-for="(company, index) in info.tenant_agents.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.tenant_agents.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Tenant Agents</td>
                                    </tr>
                                    <tr>
                                        <td >Tenant Agent Contacts:</td>
                                        <td v-if="info.tenant_agent_contacts.data.length > 0">
                                            <a class="mr-1" v-for="(contact, index) in info.tenant_agent_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.tenant_agent_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                        <td v-else class="grey--text lighten-2">No Tenant Agent Contacts</td>
                                    </tr>
                                    <tr v-if="info.prev_tenant_contacts && info.prev_tenant_contacts.data.length > 0">
                                        <td >Previous Tenant Contacts:</td>
                                        <td>
                                            <a class="mr-1" v-for="(contact, index) in info.prev_tenant_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.prev_tenant_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_tenant_agents && info.prev_tenant_agents.data.length > 0">
                                        <td >Previous Tenant Agents:</td>
                                        <td>
                                            <a class="mr-1" v-for="(company, index) in info.prev_tenant_agents.data" @click="viewCompany(company.id)"
                                            >
                                            {{ company.name }}<span v-if="index !== (info.prev_tenant_agents.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="info.prev_tenant_agent_contacts && info.prev_tenant_agent_contacts.data.length > 0">
                                        <td >Previous Tenant Agent Contacts:</td>
                                        <td>
                                            <a class="mr-1" v-for="(contact, index) in info.prev_tenant_agent_contacts.data" @click="viewUser(contact.id)"
                                            >
                                            {{ contact.name }}<span v-if="index !== (info.prev_tenant_agent_contacts.data.length - 1)">,</span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <template v-if="info.links && info.links.data.length > 0">
                            <h5 class="text-h7 mb-1 mt-6 pa-0">Links</h5>
                            <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;">
                                <template v-slot:default>
                                    <tbody class="rpd-d-tbody">
                                        <tr v-for="(item, index) in info.links.data" :key="index">
                                            <td>
                                                <a :href="item.link_url" target="_blank">{{ item.link_url }}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="10"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-skeleton-loader type="table-heading, paragraph, paragraph, paragraph, paragraph" :loading="loading" rows="6"></v-skeleton-loader>
                    </v-col>
                </v-row>
            </v-card-text>
            <edit-property-dialog ref="editPropertyDialog" @updated="getDeal"></edit-property-dialog>
            <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
            <edit-company-dialog ref="editCompanyDialog"></edit-company-dialog>
            <edit-user-dialog ref="editUserDialog"></edit-user-dialog>
        </v-card>        
    </v-dialog>
</template>
<script>
    import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
    import EditPropertyDialog from '@/components/properties/editPropertyDialog'
    import EditCompanyDialog from "@/components/companies/editCompanyDialog.vue";
    import EditUserDialog from "@/components/users/editUserDialog.vue";
    
    export default {
        components: {
            EditSchemeDialog,
            EditPropertyDialog,
            EditCompanyDialog,
            EditUserDialog
        },

        data: () => ({
            dialog: false,
            dealID: 0,
            loading: true,
            info: {},
        }),
        // props: ['dealID'],
        methods: {
            showDialog: function (dealID) {
                this.info = {};
                this.dealID = dealID;
                this.getDeal();
                
                setTimeout(() => {
                    this.dialog = true;
                }, 100);
            },
            
            closeDialog: function () {
                this.dialog = false;
            },

            async getDeal() {
                // this.loading = true;
                await this.$http.get(`/deals/${this.dealID}`, {
                    params: {
                        include: 'scheme, property, property.address, property.scheme, client, tenant, prev_tenant, tenant_legal, prev_tenant_legal, landlords, landlord_contacts, landlord_agents, landlord_agent_contacts, prev_landlords, prev_landlord_contacts, prev_landlord_agents, prev_landlord_agent_contacts, tenant_contacts, tenant_agents, tenant_agent_contacts, prev_tenant_contacts, prev_tenant_agents, prev_tenant_agent_contacts, creator, links',
                    }
                })
                    .then(response => {
                        // "id": 54,
                        // "deal_type": "new_letting",
                        // "scheme_id": null,
                        // "property_id": 69552,
                        // "created_at": "11\/09\/2024",
                        // "sale_type": null,
                        // "sale_price": null,
                        // "reason": "new_store",
                        // "tenant_id": 485,
                        // "landlord_company_id": null,
                        // "landlord_contact_id": null,
                        // "landlord_agent_company_id": null,
                        // "landlord_agent_contact_id": null,
                        // "lease_start_date": null,
                        // "lease_end_date": null,
                        // "next_review_date": null,
                        // "break_date": null,
                        // "rent_pa": null,
                        // "rent_sqft": null,
                        // "rateable_value": null,
                        // "service_charge": null,
                        // "incentive": null,
                        // "planning": "planning",
                        // "rent_review_clause": null,
                        // "break_clause": null,
                        this.info = response.data;
                        this.loading = false;
                        // this.showDialog();
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            formatData(data){
                // remove underscores and replace with space
                if(data){
                    return data.replace(/_/g, ' ');
                }
                
            },

            currencyFormat(data){
                // format currency
                if(data){
                    // format data with .
                    data = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    if(this.info.currency == 'GBP'){
                        return '£' + data
                    }else if(this.info.currency == 'USD'){
                        return '$' + data
                    }else if(this.info.currency == 'EUR'){
                        return '€' + data
                    }else{
                        return data
                    }
                }
            },
            formatDate(date) {
                // YYYY-MM-DD to DD/MM/YYYY
                if(date){
                    return date.split('-').reverse().join('/');
                }
            },

            viewCompany(companyID){
                this.$refs.editCompanyDialog.showDialog(companyID);
            },
            viewUser(userID){
                this.$refs.editUserDialog.showDialog(userID);
            },
            viewScheme(schemeID){
                this.$refs.editSchemeDialog.showDialog(schemeID, false);
            },
            viewProperty(propertyID, schemeID){
                this.$refs.editPropertyDialog.showDialog(propertyID, schemeID, false, null);
            },
        },
    }

</script>
<style>
    .deal-td{
        width: 200px;
    }
</style>